import { SET_NOTIFICATION_MSG, SET_PRIMARY_NOTIFICATION_MSG } from '../actions';

const initialState = {
  primaryNotification: '',
  primaryNotificationType: '',
  nodeTypePrimaryNotification: false,
  msg: '',
  msgType: '',
  nodeTypeMessage: false,
  autoHideMsg: false,
  closeOnBlur: true,
  onClose: () => {},
  onPrimaryClose: () => {}
};

export const notificationSelector = state => state.notification;

const notification = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_MSG: {
      const { msg, msgType, nodeTypeMessage, autoHideMsg, closeOnBlur, onClose } = action;
      return {
        ...state,
        msg,
        msgType,
        autoHideMsg,
        closeOnBlur,
        nodeTypeMessage: !!nodeTypeMessage,
        onClose: !msg ? initialState.onClose : onClose || initialState.onClose
      };
    }
    case SET_PRIMARY_NOTIFICATION_MSG: {
      const { msg, msgType, nodeTypeMessage, onClose } = action;
      return {
        ...state,
        primaryNotification: msg,
        primaryNotificationType: msgType,
        nodeTypePrimaryNotification: !!nodeTypeMessage,
        onPrimaryClose: !msg ? initialState.onPrimaryClose : onClose || initialState.onPrimaryClose
      };
    }
    default: {
      return state;
    }
  }
};

export default notification;
